export default "https://a.travel-assets.com/partner-portal/sheild.1d07aab3a7bf.svg";